import { createSlice } from '@reduxjs/toolkit';

export const flowSlice = createSlice({
  name: 'flow',
  initialState: {
    vars: [],
    tags: [],
    localVars: [],
    allVariables: [],
    codes: [],
    toastMessage: null,
    switchHandleCount: [],
    switchListe: [],
    conditionList: [],
    isModalOpenFlag: false,
  },
  reducers: {
    setVars: (state, action) => {
      state.vars = action.payload;
      state.allVariables = [...action.payload, ...state.tags, ...state.localVars];
    },
    setTags: (state, action) => {
      state.tags = action.payload;
      state.allVariables = [...state.vars, ...action.payload, ...state.localVars];
    },
    setLocalVars: (state, action) => {
      state.localVars = action.payload;
      state.allVariables = [...state.vars, ...state.tags, ...action.payload];
    },
    setAllVariables: (state, action) => {
      state.allVariables = action.payload;
    },
    setCodes: (state, action) => {
      state.codes = action.payload;
    },
    setToastMessage: (state, action) => {
      state.toastMessage = action.payload;
    },
    // Panels compatibility
    isModalOpen: (state) => { state.isModalOpenFlag = true; },
    isModalClose: (state) => { state.isModalOpenFlag = false; },
    conditionList: (state, action) => {
      const idx = state.conditionList.findIndex(i => i.id === action.payload.id);
      if (idx >= 0) state.conditionList[idx] = action.payload; else state.conditionList.push(action.payload);
    },
    // Optional: used by SwitchNode
    switchHandleCount: (state, action) => {
      const idx = state.switchHandleCount.findIndex((i) => i.id === action.payload.id);
      if (idx >= 0) state.switchHandleCount[idx] = action.payload; else state.switchHandleCount.push(action.payload);
    },
    switchListe: (state, action) => {
      const idx = state.switchListe.findIndex((i) => i.id === action.payload.id);
      if (idx >= 0) state.switchListe[idx] = action.payload; else state.switchListe.push(action.payload);
    },
  }
});

export const { setVars, setTags, setLocalVars, setAllVariables, setCodes, setToastMessage, switchHandleCount, switchListe, conditionList, isModalOpen, isModalClose } = flowSlice.actions;
export default flowSlice.reducer;
